<template>
  <div class="content">
    <div class="pictrue">
      <img :src="cartInfo.productInfo.image" class="image" />
    </div>
    <div class="text">
      <div class="text-1">
        <div class="name line2">
          <span
            style="color:#fc4141;"
            v-if="cartInfo.productInfo.hasOwnProperty('goods_area_show')"
            >{{ cartInfo.productInfo.goods_area_show }}</span
          >
          {{ cartInfo.productInfo.store_name }}
        </div>
        <div class="num" v-if="showNumber">
          x {{ goodsNumber || cartInfo.cart_num }}
        </div>
      </div>
      <div
        class="attr line2"
        v-if="cartInfo.productInfo.attrInfo.hasOwnProperty('suk')"
      >
        {{ cartInfo.productInfo.attrInfo.suk }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RefundGoodsItem",
  props: {
    showNumber: {
      type: Boolean,
      default: true
    },
    goodsNumber: {
      type: Number,
      default: 0
    },
    cartInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>

<style scoped lang="scss">
.content {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: #fff;
  & > .pictrue {
    width: 1.72rem;
    height: 1.72rem;
    img {
      width: 100%;
      height: 100%;
      background-color: #fff;
    }
  }
  .text {
    flex: 1;
    max-width: 4.8rem;
    margin-left: 0.2rem;
    .text-1 {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .name {
        width: 4rem;
        flex: 1;
      }
      .num {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
      }
    }
    .attr {
      font-size: 0.22rem;
      color: #999;
    }
  }
}
</style>
